import { CaArea, CaGroup } from '../../core';
import { currentState } from '../state';

export function moveFocusUp(value: CaArea): void {
    const state = currentState();

    let group: CaGroup;
    for (const g of state.caResult.groups) {
        if (g.areas.includes(value)) {
            group = g;
            break;
        }
    }
    const index: number = group.areas.indexOf(value);
    const nIndex = Math.max(index - 1, 0);
    group.areas.splice(index, 1);
    group.areas.splice(nIndex, 0, value);
    group.first = group.areas[0];
    group.last = group.areas[group.areas.length - 1];
}

export function moveFocusDown(value: CaArea): void {
    const state = currentState();

    let group: CaGroup;
    for (const g of state.caResult.groups) {
        if (g.areas.includes(value)) {
            group = g;
            break;
        }
    }
    const index: number = group.areas.indexOf(value);
    const nIndex = Math.min(index + 1, group.areas.length - 1);
    group.areas.splice(index, 1);
    group.areas.splice(nIndex, 0, value);
    group.first = group.areas[0];
    group.last = group.areas[group.areas.length - 1];
}
